import { render, staticRenderFns } from "./form6.vue?vue&type=template&id=5193d575&scoped=true"
import script from "./form6.vue?vue&type=script&lang=js"
export * from "./form6.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5193d575",
  null
  
)

export default component.exports